import React from 'react';

export const ScrollbarsContext = React.createContext(null);
